import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuthContext } from '@/contexts/auth';
import { setAccessToken, setRefreshToken } from '@/utils/auth';

import { Spinner } from '@/components/atoms/Spinner';

export const LoginCheckPage = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  const { saveUser } = useAuthContext();
  const searchParams = new URLSearchParams(location.search);
  const accessToken = searchParams.get('accessToken') ?? '';
  const refreshToken = searchParams.get('refreshToken') ?? '';
  const redirectRoute = searchParams.get('redirectRoute');

  useEffect(() => {
    if (accessToken && refreshToken) {
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);
      saveUser(accessToken, refreshToken);
      navigate(redirectRoute ?? '/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, refreshToken]);

  return (
    <div className="flex justify-center items-center w-full h-48">
      <Spinner reverse={true} big />
    </div>
  );
};
